import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onDismiss }) => {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white px-4 py-3 flex items-center justify-between shadow-lg"
    >
      <div className="flex items-center">
        <AlertCircle className="h-5 w-5 mr-3" />
        <span className="text-sm font-medium">{message}</span>
      </div>
      <button
        onClick={onDismiss}
        className="text-white hover:text-red-200 transition-colors"
        aria-label="Dismiss error"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};